module.exports = __webpack_public_path__ + "img/mine.98a77116.svg";